import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { changeLayoutMode } from "../../../../slices/thunks";
import { useEffect } from "react";
import Footer from "../footer";
import Navbar from "../navbar";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Importing icons

import case_study1 from "../../../../assets/images/landing/Case_Studies/dps.jpeg";
import case_study2 from "../../../../assets/images/landing/Case_Studies/jt.png";
import case_study3 from "../../../../assets/images/landing/Case_Studies/nav.png";
import case_study4 from "../../../../assets/images/landing/Case_Studies/jewellary.jpg";
import case_study5 from "../../../../assets/images/landing/Case_Studies/HectorPipes.jpg";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  hover: {
    scale: 1.05,
    boxShadow: "0 10px 20px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.06)",
    transition: { duration: 0.3 },
  },
};

const caseStudies = [
  {
    image: case_study1,
    title: "DPS Raigarh",
    description: "Streamlining University Administration with Infinity ERP",
    link: "/case_1",
  },
  {
    image: case_study2,
    title: "Jagadambha Trailors",
    description:
      "Enhancing Operational Efficiency at Jagadamba Trailers with Infinity ERP",
    link: "/case_2",
  },
  {
    image: case_study3,
    title: "Navdurga Group",
    description:
      "Transforming Steel Manufacturing Operations with Infinity ERP",
    link: "/case_3",
  },
  {
    image: case_study4,
    title: "Rambhagat Laxminarayan Jewelry",
    description: "Elevating Jewelry Manufacturing Efficiency",
    link: "/case_4",
  },
  {
    image: case_study5,
    title: "Hector Pipes",
    description: "Optimizing Steel Manufacturing Operations",
    link: "/case_5",
  },
];

const CaseStudiesPage = () => {
  const dispatch = useDispatch();
  const swiperRef = useRef(null); // Reference to the Swiper instance

  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if (layoutModeType) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar
        onChangeLayoutMode={onChangeLayoutMode}
        layoutModeType={layoutModeType}
      />
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="py-5 bg-light"
      >
        <Container>
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-5"
          >
            <h1 className="display-4 mb-3 mt-4">Our Case Studies</h1>
            <p className="lead text-muted">
              Transforming Businesses Through Innovative Solutions
            </p>
          </motion.div>

          <Swiper
            ref={swiperRef}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            breakpoints={{
              640: {
                slidesPerView: 1, // One card per view on small screens
              },
              768: {
                slidesPerView: 2, // Two cards per view on tablets
              },
              1024: {
                slidesPerView: 3, // Three cards per view on larger screens
              },
            }}
          >
            {caseStudies.map((study, index) => (
              <SwiperSlide key={index}>
                <motion.div variants={cardVariants} whileHover="hover">
                  <Card className={`border-0 shadow-sm h-100 card`}>
                    <div
                      className="overflow-hidden"
                      style={{ height: "250px" }}
                    >
                      <Card.Img
                        variant="top"
                        src={study.image}
                        className="img-fluid object-cover"
                        style={{
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title as="h5" className="mb-3">
                        {study.title}
                      </Card.Title>
                      <Card.Text className="text-muted mb-4">
                        {study.description}
                      </Card.Text>
                      <Button href={study.link} className="w-100">
                        Explore Case Study
                      </Button>
                    </Card.Body>
                  </Card>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="d-flex justify-content-between mt-4">
            <Button
              variant="link"
              onClick={() => swiperRef.current.swiper.slidePrev()}
            >
              <FaChevronLeft size={30} />
            </Button>
            <Button
              variant="link"
              onClick={() => swiperRef.current.swiper.slideNext()}
            >
              <FaChevronRight size={30} />
            </Button>
          </div>
        </Container>
      </motion.div>
      <Footer />
    </div>
  );
};

export default CaseStudiesPage;